import { z } from "zod";
import { hc } from "hono/client";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { withAuth } from "@/utils/withAuth";
import type { UserRoutes } from "server/super-user";

export const userClient = hc<UserRoutes>(
  import.meta.env.VITE_SERVER_URL + "v1/super-user",
);

export const superuserSchema = z.object({
  sub: z.string(),
  email: z.string(),
  createdAt: z.string(),
});

export type Superuser = z.infer<typeof superuserSchema>;

/**
 * GET all superusers from the server
 */
async function fetchSuperusers(): Promise<Superuser[]> {
  return withAuth(async (headers) => {
    const response = await userClient.superusers.$get({}, { headers });
    if (!response.ok) {
      throw new Error("Failed to fetch superusers");
    }
    return response.json();
  });
}

export const superusersQueryOptions = queryOptions({
  queryKey: ["superusers"],
  queryFn: fetchSuperusers,
});

export function useSuperusers() {
  return useQuery(superusersQueryOptions);
}
